// extracted by mini-css-extract-plugin
export default {"wrap":"GF-z","fullWidth":"HF-z","hideOnDesktop":"IF-z","content":"JF-z","hasOpenedNav":"KF-z","crumbsList":"LF-z","dropdownsWrap":"MF-z"};